import { EAdaptMode } from '../../modifiers/Adapt';
import { ShapeBuffer } from '../ShapeBuffer';
/**
 * Triangle ShapeBuffer
 *
 * @category Shapes.ShapeBuffer
 */
class Triangle extends ShapeBuffer {
    /**
     * Creates an instance of Triangleeee.
     *
     * @param {ShapeBaseSettings} [settings={}]
     * @memberof Triangle
     */
    constructor(settings = {}) {
        settings.type = 'Triangle';
        settings.shape = Triangle.buffer;
        settings.adaptMode = EAdaptMode.None;
        super(settings);
    }
}
Triangle.buffer = Float32Array.from([1, 0, -1, 1, -1, -1]);
export { Triangle };
//# sourceMappingURL=Triangle.js.map